import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isAppLocale, LOCALE_TO_AI_TRIP_IFRAME_LANG } from '@/constants/appLocale';

const AI_TRIP_IFRAME_ORIGIN = 'https://lc-xc.cookieboty.tech/';

const AITrip = () => {
  const { i18n } = useTranslation();

  const iframeSrc = useMemo(() => {
    const locale = isAppLocale(i18n.language) ? i18n.language : 'zh_CN';
    const lang = LOCALE_TO_AI_TRIP_IFRAME_LANG[locale];
    const url = new URL(AI_TRIP_IFRAME_ORIGIN);
    url.searchParams.set('lang', lang);
    return url.toString();
  }, [i18n.language]);

  return (
    <div className="w-full">
      <iframe
        key={iframeSrc}
        className="w-full"
        style={{ minHeight: 400, border: 0, height: '100vh' }}
        src={iframeSrc}
        title="AI Trip"
      />
    </div>
  );
};

export default AITrip;
